export const COOKIE_TYPES = {
  STRICTLY_NECESSARY: "STRICTLY_NECESSARY",
  FUNCTIONAL: "FUNCTIONAL",
  MARKETING_ANALYTICS: "MARKETING_ANALYTICS",
  ADS: "ADS"
};
